import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Payee } from '../../shared/sdk/models';
import { PayeeApi, ServiceApi } from '../../shared/sdk/services';
import { GlobalEventsManager } from '../../events-manager.component';
var ɵ0 = window;
var ConsentComponent = /** @class */ (function () {
    function ConsentComponent(document, router, userApi, serviceApi, eventsManager) {
        this.document = document;
        this.router = router;
        this.userApi = userApi;
        this.serviceApi = serviceApi;
        this.eventsManager = eventsManager;
        this.declaration = false;
        this.valid = true;
    }
    // Initialisation
    ConsentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventsManager.loaded(true);
        this.userApi.findById(this.userApi.getCurrentId()).subscribe(function (res) {
            var payee = res;
            if (payee.pre_form_declaration) {
                _this.eventsManager.loaded(false);
                _this.router.navigate(['/form']);
            }
        }, function (err) {
            console.log(err);
        });
    };
    // Validation
    ConsentComponent.prototype.validate = function () {
        var _this = this;
        this.valid = true;
        var elements = this.document.getElementsByName('declaration')[0].getElementsByClassName('ng-invalid');
        if (this.valid && elements.length == 0) {
            this.userApi.patchAttributes(this.userApi.getCurrentId(), { 'pre_form_declaration': this.declaration }).subscribe(function (res) {
                _this.eventsManager.loaded(false);
                _this.router.navigate(['/form']);
            }, function (err) {
                _this.eventsManager.showPopUp("An error has occured. Please try again later.");
            });
        }
        else {
            this.valid = false;
            if (elements.length != 0) {
                console.log(elements[0]);
            }
            this.eventsManager.showPopUp("The declaration of consent must be checked to proceed with your application.");
            // this.router.navigate(['/submit']);
        }
    };
    ConsentComponent.prototype.change = function (page) {
        if (page == 'Services') {
            this.router.navigate(['/chooseBusiness']);
            return;
        }
    };
    // Scrolling
    ConsentComponent.prototype.scrollToTop = function () {
        //window.scroll(0, 0);
        //this.document.body.getElementsByClassName('scroll_declaration')[0].scrollTop = 0;
    };
    return ConsentComponent;
}());
export { ConsentComponent };
export { ɵ0 };
